/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_EditInputs */

const en_consumer_declaration_edit = /** @type {(inputs: Consumer_Declaration_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit details`)
};

const de_consumer_declaration_edit = /** @type {(inputs: Consumer_Declaration_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angaben bearbeiten`)
};

const fr_consumer_declaration_edit = /** @type {(inputs: Consumer_Declaration_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier les informations`)
};

const es_consumer_declaration_edit = /** @type {(inputs: Consumer_Declaration_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar datos`)
};

const it_consumer_declaration_edit = /** @type {(inputs: Consumer_Declaration_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifica dati`)
};

const nl_consumer_declaration_edit = /** @type {(inputs: Consumer_Declaration_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegevens wijzigen`)
};

const pl_consumer_declaration_edit = /** @type {(inputs: Consumer_Declaration_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edytuj dane`)
};

const fi_consumer_declaration_edit = /** @type {(inputs: Consumer_Declaration_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muokkaa tietoja`)
};

const da_consumer_declaration_edit = /** @type {(inputs: Consumer_Declaration_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rediger oplysninger`)
};

const sv_consumer_declaration_edit = /** @type {(inputs: Consumer_Declaration_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redigera uppgifter`)
};

/**
* | output |
* | --- |
* | "Edit details" |
*
* @param {Consumer_Declaration_EditInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_edit = /** @type {((inputs?: Consumer_Declaration_EditInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_EditInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_edit(inputs)
	if (locale === "fr") return fr_consumer_declaration_edit(inputs)
	if (locale === "es") return es_consumer_declaration_edit(inputs)
	if (locale === "it") return it_consumer_declaration_edit(inputs)
	if (locale === "nl") return nl_consumer_declaration_edit(inputs)
	if (locale === "pl") return pl_consumer_declaration_edit(inputs)
	if (locale === "fi") return fi_consumer_declaration_edit(inputs)
	if (locale === "da") return da_consumer_declaration_edit(inputs)
	if (locale === "sv") return sv_consumer_declaration_edit(inputs)
	return en_consumer_declaration_edit(inputs)
});